"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var ParagraphStyled = _styledComponents.default.p.withConfig({
  displayName: "Paragraph__ParagraphStyled",
  componentId: "sc-3dsdwt-0"
})(["", " color:", ";font-family:", ";em{font-style:italic;}strong{font-weight:bold;}small{", "}"], function (_ref) {
  var theme = _ref.theme;
  return theme.typeScale.default.toString();
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.gunMetal;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.font.primaryRegular;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typeScale.small.toString();
});
var _default = exports.default = ParagraphStyled;